<template>
    <div class="acomodar">
        <DescuentoTecnologia/>
    </div>
</template>

<script>
import DescuentoTecnologia from '@/components/ModContratos/DesTecnologia/Tecnologia.vue';
import '@/assets/styles/global-acomodar.css'; // Importar el estilo global

export default {
    name: 'SolimanologDescuentoTecnologia',
    components:{
        DescuentoTecnologia
    },
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

